import React from 'react';
export function CampaignArchiveIcon(props) {
  var className = props && props.className ? 'wink-icon ' + props.className : 'wink-icon';
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true"
  }, props, {
    className: className
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 12a1 1 0 100 2h6a1 1 0 100-2H9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 2a3 3 0 00-3 3v2c0 .888.386 1.687 1 2.236V19a3 3 0 003 3h12a3 3 0 003-3V9.236c.614-.55 1-1.348 1-2.236V5a3 3 0 00-3-3H5zm1 6H5a1 1 0 01-1-1V5a1 1 0 011-1h14a1 1 0 011 1v2a1 1 0 01-1 1h-1a2 2 0 00-2-2H8a2 2 0 00-2 2zm13 2v9a1 1 0 01-1 1H6a1 1 0 01-1-1v-9h14z"
  }));
}